import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import createPersistedState from "./persistedstate";
import message from "./modules/message";
Vue.use(Vuex);

// https://webpack.js.org/guides/dependency-management/#requirecontext
var modulesFiles = require.context("./modules", true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
var modules = modulesFiles.keys().reduce(function (modules, modulePath) {
  // set './app.js' => 'app'
  var moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  var value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});
var store = new Vuex.Store({
  modules: _objectSpread(_objectSpread({}, modules), {}, {
    message: message
  }),
  getters: getters,
  plugins: [
  // if you need more persisted module, just add value to [paths]
  createPersistedState({
    paths: ["tagsView", "InPurchasePlan"]
  })]
});
export default store;